module.exports = __webpack_public_path__ + "img/location.7d6a3d73.svg";